<div class="btn-group btn-group-lg d-flex d-md-inline-flex flex-column flex-md-row" role="group" aria-label="Radio toggle button group">
  <ng-container *ngFor="let button of buttonValues?.buttons; let i = index">
    <input
      type="radio"
      class="btn-check"
      [value]="button.value"
      [name]="buttonValues.groupName"
      [id]="'id-'+buttonValues.groupName+'-'+(button.id ? button.id : i)"
      autocomplete="off"
      (change)="setValue(button.value)"
      [checked]="selectedValue === button.value"
    >
    <label
      [class.faded]="fadedButtons && selectedValue && selectedValue !== button.value"
      [class.active]=" selectedValue === button.value"
      [class.error]="showError"
      (click)="setValue(button.value)"
      class="btn btn-outline-primary"
      [attr.yp-e2e-id]="'e2e-'+buttonValues.groupName+'-'+(button.id ? button.id : i)"
    >
      {{button.label}}
    </label>
  </ng-container>
</div>
